import { HTTPService as Srv } from '@services';

export const $turn_fetchAll = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ from = 0 || null, to = 0 || null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/get/all',
				{
					from,
					to,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_edit = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = null, isAttempted = null, turn = null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/edit',
				{
					id,
					isAttempted,
					turn,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_save = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ turn = null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/save',
				{
					turn,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_rating = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ TurnType = null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/turnrating',
				{
					TurnType,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_removeUser = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/removeuser',
				{
					id,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_removeTurn = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = null, ...body }, // => body
	header,
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/delete',
				{
					id,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_getDate = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ date = null, ...body }, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/get/date',
				{
					date,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_take = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		name = null,
		lastName = null,
		nationalNumber = null,
		birthPlace = null,
		birthDate = null,
		gender = null,
		nationality = null,
		address = null,
		postalCode = null,
		turnId = null,
		cellphone = null,
		code = null,
		currency = null,
		amount = null,
		phone = null,
		...body
	}, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/take',
				{
					name,
					lastName,
					nationalNumber,
					birthPlace,
					birthDate,
					gender,
					nationality,
					address,
					postalCode,
					turnId,
					cellphone,
					code,
					currency,
					amount,
					phone,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $turn_getId = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		id = null,

		...body
	}, // => body
	header = {},
	version = 'v2',
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'turn/get/id',
				{
					id,
					...body,
				},
				header,
				version,
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});
